<div *ngIf="conceptFilter" class="container" [@.disabled]="disableAnimation">
  <num-shared-concept-filter
    *ngIf="conceptFilter"
    [conceptFilterId]="conceptFilter.getId()"
    [preSelectedConcepts]="conceptFilter.getSelectedConcepts()"
    [valueSetUrl]="conceptFilter.getAllowedConceptUrls()"
    (changedSelectedConcepts)="emitConceptFilter($event)"
  >
  </num-shared-concept-filter>
</div>
